/**
 *
 * ControlPanelUserManagementAmbassador
 *
 */

import React from "react"
import {
  DatePicker,
  Button,
  Table,
  Spin,
  Input,
  Tooltip,
  Empty,
  Popover,
  Checkbox,
} from "antd"
import { Form } from "@ant-design/compatible"
import { connect } from "react-redux"
import { createStructuredSelector } from "reselect"
import { compose } from "redux"
import { Link } from "react-router-dom"

import injectSaga from "utils/injectSaga"
import injectReducer from "utils/injectReducer"
import {
  makeSelectIsLoadingDetails,
  makeSelectListDivisions,
  makeSelectListEmployees,
  makeSelectCountAmbassadors,
  makeSelectCountEmployees,
  makeSelectListAmbassador,
  makeSelectIsLoadingCreate,
  makeSelectIsLoadingAmbassadors,
  makeSelectCountAllAmbassadors,
  makeSelectIsDownloading,
  makeSelectLanguage,
} from "./selectors"
import {
  getEmployeesDivisionsWatcher,
  listAmbassadorsWatcher,
  createAmbassadorWatcher,
  deleteAmbassadorWatcher,
  getLanguageWatcher,
  getTemplate,
} from "./actions"
import reducer from "./reducer"
import saga from "./saga"
import Select from "components/Select"
import ModalCustom from "components/ModalCustom"
import ModalAmbassadorAssign from "components/ModalAmbassadorAssign"
import ModalAmbassadorDelete from "components/ModalAmbassadorDelete"
import plusIcon from "images/plus.svg"
import backIcon from "images/left-arrow.svg"
import checkIcon from "images/check-measure.svg"

import { flatMap, debounce, isEqual } from "lodash"
import imageEmptyFreemium from "images/empty/empty-balloon.svg"
import { requestUpgradeApi } from "services/requestUpgrade"
import moment from "moment"
import "@ant-design/compatible/assets/index.css"
import {
  MinusCircleFilled,
  CloseCircleOutlined,
  SearchOutlined,
  UploadOutlined,
  DownloadOutlined,
  QuestionCircleFilled,
} from "@ant-design/icons"
import ModalEmail from "./Components/ModalEmail"

import { woopraTrack } from "../../../../utils/woopra/woopraTracker"

import "./index.less"
import { buttonAction_btns } from "../../../../components/Snowplow/config2"

/* eslint-disable react/prefer-stateless-function */
export class ControlPanelUserManagementAmbassador extends React.Component {
  state = {
    modalCreate: false,
    modalDelete: false,
    modalAssign: false,
    modalSelectDateExport: false,
    currentRange: [null, moment()],
    selectedDivision: [],
    selectedEmployee: [],
    currentAmbassador: {},
    textFilter: "",
    sortField: null,
    sortOrder: null,
    isFilter: false,
    sortOrderBackup: null,
    modalEmail: false,
    usersSelected: [],
    usersSelectedTable: [],
    checkSendInvitation: true,
  }

  componentDidMount() {
    this.props.getDetails()
    this.props.listAmbassadors()
    this.first_load = false
  }

  handleTableChange = (pagination, filters, sorter) => {
    if (sorter.order && !isEqual(this.state.sortOrderBackup, sorter)) {
      this.setState(
        {
          sortField: sorter.field,
          sortOrderBackup: sorter,
          sortOrder: sorter.order ? sorter.order.substring(0, 3) : null,
        },
        () => {
          this.loadData()
        }
      )
    }
  }

  loadData = () => {
    this.props.listAmbassadors({
      sortField: this.state.sortField,
      sortOrder: this.state.sortOrder,
      search: this.state.textFilter,
    })
  }

  changeRange = (value, dateString) => {
    this.setState({ currentRange: value })
  }

  disabledRangeDate = (current, type) => {
    return current > moment().endOf("day")
  }

  pressAddAmbassador = () => {
    const { selectedDivision, selectedEmployee } = this.state
    this.props.createAmbassador({
      divisions: flatMap(selectedDivision, (item) => {
        return { id_division: item.id_division }
      }),
      employees: flatMap(selectedEmployee, (item) => {
        return { id_employee: item.id_employee }
      }),
    })
  }

  searchWithDebounce = debounce(() => {
    this.setState(
      {
        isFilter: true,
      },
      () => this.loadData()
    )
  }, 500)

  renderEmpty = () => {
    const {
      count_employees,
      isLoadingAmbassadors,
      count_ambassadors,
    } = this.props
    if (count_employees === 0 && !isLoadingAmbassadors) {
      return (
        <div style={{ padding: "1rem", textAlign: "center", color: "#555155" }}>
          {/* <p>No es posible asignar embajadores sin haber primero cargado <b>colaboradores</b> al sistema.</p> */}
          <p>
            No es posible asignar embajadores sin haber primero cargado{" "}
            <b>colaboradores con correo eléctronico</b> al sistema.
          </p>
          <Button style={{ color: "#2694FC", marginTop: "0.5rem" }}>
            <Link to="organization#collaborators">
              <img alt="back-icon" src={backIcon} style={{ marginRight: 10 }} />
              Ir a Colaboradores
            </Link>
          </Button>
        </div>
      )
    }
    if (
      count_ambassadors === 0 &&
      !isLoadingAmbassadors &&
      !this.state.isFilter
    ) {
      return (
        <p
          style={{
            border: "1px solid #EDE9E9",
            padding: "1rem",
            textAlign: "center",
            color: "#A2A2A2",
          }}>
          No hay embajadores asignados para mostrar.
        </p>
      )
    }
  }

  rowSelection = {
    onChange: (selectedRowKeys, selectedRows) => {
      this.setState({
        usersSelectedTable: selectedRows,
      })
    },
    getCheckboxProps: (record) => ({
      name: record.name,
    }),
  }

  renderIconQuestion = () => {
    return (
      <Popover
        placement="top"
        content={
          <div style={{ maxWidth: 245, textAlign: "center" }}>
            El embajador recibirá un{" "}
            <b>
              correo de
              <br /> invitación
            </b>{" "}
            al sistema al ser asignado.
          </div>
        }>
        <QuestionCircleFilled className="UserManagement-Ambassador-icon-question" />
      </Popover>
    )
  }

  render() {
    const { RangePicker } = DatePicker

    let {
      selectedEmployee,
      selectedDivision,
      modalCreate,
      modalDelete,
      currentAmbassador,
      textFilter,
      modalAssign,
      modalEmail,
      usersSelected,
      usersSelectedTable,
      checkSendInvitation,
    } = this.state

    let {
      list_divisions,
      list_employees,
      list_ambassadors,
      count_employees,
      count_ambassadors,
      form,
      isLoadingCreate,
      isLoadingDetails,
      isLoadingAmbassadors,
      count_all_ambassadors,
    } = this.props

    const columns = [
      {
        title: "Nombre",
        dataIndex: "first_name",
        sorter: true,
        width: "20%",
      },
      {
        title: "Apellidos",
        dataIndex: "last_name",
        sorter: true,
        width: "20%",
        render: (last_name, record) => (
          <span>
            {record.last_name} {record.second_last_name}
          </span>
        ),
      },
      {
        title: "División",
        dataIndex: "divisions",
        sorter: true,
        render: (divisions) =>
          flatMap(divisions, (item) => item.name).join(", "),
      },
      {
        title: "Correo de invitación",
        dataIndex: "user_invited",
        className: "leadersOptionSend",
        render: (user_invited, row) => {
          const send = (
            <span
              style={{ cursor: "pointer", color: "#1890ff" }}
              onClick={() => {
                this.setState({
                  usersSelected: [{ ...row }],
                  modalEmail: true,
                })
                buttonAction_btns("Reenviar invitacion a embajador")
              }}>
              {user_invited ? "Reenviar" : "Enviar"}
            </span>
          )

          return !user_invited ? (
            send
          ) : (
            <>
              <img
                className="leadersOptionSend-image"
                style={{ width: 12, height: 11 }}
                src={checkIcon}
              />
              <div className="leadersOptionSend-action">{send}</div>
            </>
          )
        },
      },
      {
        title: " ",
        width: "100",
        render: (row, record) => (
          <div style={{ textAlign: "right" }}>
            <MinusCircleFilled
              style={{
                color: "#F07F7F",
                fontSize: 16,
                verticalAlign: "middle",
              }}
              onClick={() =>
                this.setState({
                  modalDelete: true,
                  currentAmbassador: record,
                })
              }
            />
          </div>
        ),
      },
    ]

    const usersSelectedToInvite = usersSelectedTable.filter(
      (e) => parseInt(e.user_invited) === 0
    )

    return (
      <div>
        {count_employees > 0 && (
          <div
            className="container-usermanagement__actions"
            style={{ top: 8, display: "flex" }}>
            <Button
              disabled={isLoadingDetails}
              type="primary"
              onClick={() => {
                woopraTrack("Asignar embajador")
                this.setState({ modalCreate: true })
              }}>
              <img src={plusIcon} />
            </Button>
            <Tooltip placement="topRight" title="Importar embajadores">
              <Button
                className="whiteButton"
                size="default"
                style={{ marginLeft: 8 }}
                icon={<UploadOutlined />}
                onClick={() => {
                  woopraTrack("Importar embajadores")
                  this.props.history.push("/ambassador/import")
                }}
              />
            </Tooltip>
            {count_all_ambassadors > 0 && (
              <Tooltip
                placement="topRight"
                title={
                  <p style={{ textAlign: "center", marginBottom: "0px" }}>
                    Exportar embajadores y<br />
                    métricas de uso
                  </p>
                }>
                <Button
                  className="whiteButton"
                  size="default"
                  loading={this.props.isDownloading}
                  style={{ marginLeft: 8 }}
                  icon={<DownloadOutlined />}
                  onClick={() => this.setState({ modalSelectDateExport: true })}
                />
              </Tooltip>
            )}
          </div>
        )}

        <div
          className="container-usermanagement__tab-title color-black"
          style={{
            color: count_employees === 0 ? "#A2A2A2" : "",
          }}>
          Embajadores de Clima Laboral y Engagement{" "}
          <span className="color-gray-low">
            {count_ambassadors ? `(${count_ambassadors})` : ""}
          </span>
        </div>
        <p
          className="container-usermanagement__tab-description color-black"
          style={{
            color: count_employees === 0 ? "#A2A2A2" : "",
            marginBottom: 10,
          }}>
          Los usuarios asignados como <b>embajadores</b> estarán a cargo de
          ejecutar planes de acción con el objetivo de mejorar el{" "}
          <b>Clima Laboral y Engagement</b> de la división a la que son
          asignados. En ese sentido, tendrán visibilidad de los resultados de su
          división, y las divisiones debajo. Es posible asignar más de un
          embajador por división, y más de una división por embajador.
        </p>
        <p
          style={{
            color: count_employees === 0 ? "#A2A2A2" : "",
          }}>
          <b>¡Recuerda!</b> Solo pueden ser usuarios embajadores colaboradores
          cuyo correo electrónico haya sido cargado al sistema.
        </p>
        {count_all_ambassadors > 0 && (
          <div
            style={{
              marginTop: 20,
              marginBottom: "1.5rem",
              display: "flex",
              alignItems: "end",
            }}>
            <Input
              placeholder="Buscar..."
              style={{ width: 300 }}
              value={textFilter}
              onChange={(e) => {
                this.setState({ textFilter: e.target.value }, () =>
                  this.searchWithDebounce()
                )
              }}
              suffix={
                textFilter ? (
                  <CloseCircleOutlined
                    style={{
                      cursor: "pointer",
                      color: "white",
                      background: "rgba(0, 0, 0, 0.25)",
                      borderRadius: "50%",
                    }}
                    onClick={() => {
                      this.setState({ textFilter: "", isFilter: false }, () => {
                        return this.loadData()
                      })
                    }}
                  />
                ) : (
                  <SearchOutlined />
                )
              }
            />

            <Button
              onClick={() => {
                this.setState({
                  usersSelected: usersSelectedToInvite,
                  modalEmail: true,
                })
                buttonAction_btns("Enviar invitacion a embajador")
              }}
              disabled={usersSelectedToInvite.length === 0}
              style={{ marginLeft: "auto" }}
              type="primary">
              Enviar invitación
            </Button>
          </div>
        )}

        <>
          {this.renderEmpty()}

          {isLoadingAmbassadors && count_all_ambassadors === 0 && (
            <div className="loadingSpin">
              <Spin size="large" />
            </div>
          )}

          {count_all_ambassadors > 0 && (
            <Table 
              className="container-usermanagement__table table-with-options"
              columns={columns}
              rowKey={(record) => record.id_user}
              dataSource={
                Array.isArray(list_ambassadors) ? list_ambassadors : []
              }
              rowSelection={this.rowSelection}
              loading={isLoadingAmbassadors}
              onChange={this.handleTableChange}
              locale={{ emptyText: "No hay embajadores para mostrar" }}
              pagination={{
                pageSizeOptions: ["15", "25", "50", "100"],
                showSizeChanger: true,
                size: "default",
                defaultPageSize: 15,
              }}
            />
          )}
        </>

        <ModalCustom
          width={520}
          title="Asignar Embajador de Clima Laboral y Engagement"
          model="Embajador"
          action="Asignar embajador"
          closable={false}
          modalOpen={modalCreate}
          margin="0"
          onOk={() => {
            this.props.form.validateFieldsAndScroll((err, values) => {
              if (!err) {
                this.setState({
                  modalAssign: true,
                  modalCreate: false,
                })
              }
            })
          }}
          onCancel={() => {
            this.setState({ modalCreate: false }, () => {
              this.setState({
                selectedDivision: [],
                selectedEmployee: [],
              })
              this.props.form.resetFields()
            })
          }}
          textAlign="left"
          showFooter
          textButton="Asignar"
          disabledButton={
            !(
              isLoadingCreate ||
              (selectedDivision.length > 0 && selectedEmployee.length > 0)
            )
          }>
          <div className="editModal">
            <p>
              Ingresa la <b>división</b> para la que deseas asignar un nuevo
              embajador:
            </p>
            <Form.Item>
              {form.getFieldDecorator("selectedDivision", {
                initialValue: selectedDivision,
                rules: [
                  {
                    required: true,
                    message: formLabelMessage("es", "required"),
                  },
                ],
              })(
                <Select
                  multi
                  onChange={(selectedDivision) => {
                    this.setState({ selectedDivision })
                  }}
                  options={list_divisions}
                  labelKey="id_division"
                  label="name"
                  style={{ width: 350 }}
                  placeholder="Seleccionar división"
                />
              )}
            </Form.Item>

            <p>
              Ingresa el <b>nombre del embajador</b> que deseas asignar:
            </p>
            <Form.Item>
              {form.getFieldDecorator("selectedEmployee", {
                initialValue: selectedEmployee,
                rules: [
                  {
                    required: true,
                    message: formLabelMessage("es", "required"),
                  },
                ],
              })(
                <Select
                  multi
                  onChange={(selectedEmployee) => {
                    this.setState({ selectedEmployee })
                  }}
                  options={list_employees}
                  allowClear
                  labelKey="id_employee"
                  label="full_name"
                  placeholder="Escribe aquí el nombre..."
                  style={{ width: 350 }}
                />
              )}
            </Form.Item>

            <div className="UserManagement-Ambassador-checkbox">
              <Checkbox
                onChange={(e) =>
                  this.setState({
                    checkSendInvitation: e.target.checked,
                  })
                }
                checked={checkSendInvitation}>
                Enviar correo de invitación al sistema{" "}
                {this.renderIconQuestion()}
              </Checkbox>
            </div>
          </div>
        </ModalCustom>

        <ModalCustom
          modalOpen={this.state.modalSelectDateExport}
          title="Exportar embajadores y métricas de uso"
          showFooter
          disabledButton={
            !(
              this.state.currentRange[0] != null &&
              this.state.currentRange[1] != null
            )
          }
          width={535}
          textButton="Exportar"
          onOk={() => {
            woopraTrack("Exportar embajadores")
            this.setState({ modalSelectDateExport: false }, () => {
              this.props.getTemplate(this.state.currentRange)
              this.setState({ currentRange: [null, moment()] })
            })
          }}
          onCancel={() =>
            this.setState({
              modalSelectDateExport: false,
              currentRange: [null, moment()],
            })
          }>
          <span
            style={{ fontWeight: "normal", fontSize: 13, textAlign: "left" }}>
            El documento a descargar te brindará información sobre los usuarios{" "}
            <span className="bold">embajadores</span> creados en el sistema y el{" "}
            <span className="bold">uso</span> que están haciendo de la
            plataforma.
          </span>
          <br />
          <span
            style={{
              fontWeight: "normal",
              fontSize: 13,
              textAlign: "left",
              marginBottom: "10px",
            }}>
            Selecciona el <span className="bold">rango de fechas</span> para el
            cuál deseas generar las métricas:
          </span>
          <div style={{ maxWidth: "320px" }}>
            <RangePicker
              value={this.state.currentRange}
              ranges={{
                "Mes actual": [moment().startOf("month"), moment()],
                "Últimos dos mes": [moment().subtract(2, "months"), moment()],
                "Último trimestre": [moment().subtract(3, "months"), moment()],
              }}
              onChange={this.changeRange}
              disabledDate={this.disabledRangeDate}
              placeholder={["Fecha inicio", "Fecha fin"]}
              format="DD/MM/YYYY"
              separator="-"
              size="medium"
            />
          </div>
          <span
            style={{ textAlign: "left", fontSize: "10px", marginTop: "10px" }}>
            <span className="bold">*Nota:</span> No se cuenta con información
            para los indicadores{" "}
            <span className="bold">Ingresos a la plataforma</span>,{" "}
            <span className="bold">Tiempo promedio por sesion</span> y{" "}
            <span className="bold">Última fecha de ingreso al sistema</span>{" "}
            anterior al 29 de abril del 2020.
          </span>
        </ModalCustom>

        <ModalAmbassadorDelete
          currentAmbassador={currentAmbassador}
          open={modalDelete}
          onCancel={() => {
            this.setState({ modalDelete: false, userSelected: {} })
          }}
          onFinish={() => {
            this.setState({ modalDelete: false, userSelected: {} })
            this.loadData()
          }}
        />

        <ModalAmbassadorAssign
          languages={this.props.languages}
          getLanguage={this.props.getLanguage}
          selectedDivision={selectedDivision}
          selectedEmployee={selectedEmployee}
          open={modalAssign}
          onCancel={() => {
            this.setState({ modalCreate: true, modalAssign: false })
            this.props.form.resetFields()
          }}
          onFinish={() => {
            this.setState({
              modalAssign: false,
              selectedDivision: [],
              selectedEmployee: [],
            })
            this.props.form.resetFields()
            this.loadData()
          }}
          showCheckBox={false}
          checkSendInvitation={this.state.checkSendInvitation}
        />

        <ModalEmail
        languages={this.props.languages}
        getLanguage={this.props.getLanguage}
          onFinish={() => {
            this.setState({ modalEmail: false })
            this.loadData()
          }}
          open={modalEmail}
          onCancel={() => this.setState({ modalEmail: false })}
          usersSelected={usersSelected}
        />
      </div>
    )
  }
}

const mapStateToProps = createStructuredSelector({
  isLoadingAmbassadorsCreate: makeSelectIsLoadingCreate(),
  isLoadingDetails: makeSelectIsLoadingDetails(),
  list_employees: makeSelectListEmployees(),
  list_divisions: makeSelectListDivisions(),
  count_employees: makeSelectCountEmployees(),
  count_ambassadors: makeSelectCountAmbassadors(),
  list_ambassadors: makeSelectListAmbassador(),
  isLoadingCreate: makeSelectIsLoadingCreate(),
  isLoadingAmbassadors: makeSelectIsLoadingAmbassadors(),
  count_all_ambassadors: makeSelectCountAllAmbassadors(),
  isDownloading: makeSelectIsDownloading(),
  languages: makeSelectLanguage(),
})

function mapDispatchToProps(dispatch) {
  return {
    getDetails: (params) => dispatch(getEmployeesDivisionsWatcher(params)),
    listAmbassadors: (params) => dispatch(listAmbassadorsWatcher(params)),
    createAmbassador: (params) => dispatch(createAmbassadorWatcher(params)),
    deleteAmbassador: (params) => dispatch(deleteAmbassadorWatcher(params)),
    getTemplate: (params) => dispatch(getTemplate(params)),
    getLanguage: (params) => dispatch(getLanguageWatcher(params)),
  }
}

const withConnect = connect(mapStateToProps, mapDispatchToProps)

const withReducer = injectReducer({
  key: "controlPanelUserManagementAmbassador",
  reducer,
})
const withSaga = injectSaga({
  key: "controlPanelUserManagementAmbassador",
  saga,
})

export default compose(
  withReducer,
  withSaga,
  withConnect
)(
  Form.create({ name: "ambassador_modal_create" })(
    ControlPanelUserManagementAmbassador
  )
)
